import aboutTeam from "../assets/Asset-about.webp";
import partnerMeaningful from "../assets/why parter/meaningful.svg";
import partnerCrs from "../assets/why parter/crs.svg";
import partnerIndustry from "../assets/why parter/Industry.svg";
import partnerAccountability from "../assets/why parter/accountability.svg";
import serveFrame1 from "../assets/what we ser/Frame1.webp";
import serveFrame2 from "../assets/what we ser/Frame2.webp";
import serveFrame3 from "../assets/what we ser/Frame3.webp";
import serveFrame4 from "../assets/what we ser/Frame4.webp";
import emergingWorkforce from "../assets/emerging-workforce.webp";
import heroimage from "../assets/image hero.webp";
import throughSkill from "../assets/through-skill.webp";
import aboutSectionBg from "../assets/BG.webp";
import wesinceSeal from "../assets/wesince.svg";
import enhanceEmployability from "../assets/Enhance.svg";
import promoteInnovation from "../assets/promote.svg";
import infrastructureAwareness from "../assets/infrastructure.svg";
import socioEconomicInclusion from "../assets/socia.svg";
import Architecture from "../assets/our Team/Architecture Practitioners.webp";
import Engineering from "../assets/our Team/Engineering Professionals.webp";
import SkillDevelopment from "../assets/our Team/Skill Development Trainers.webp";
import Administrative from "../assets/our Team/Administrative Coordinators.webp";
import IndustryMentors from "../assets/our Team/Industry Mentors.webp";
import ResearchContributors from "../assets/our Team/Research Contributors.webp";
import executiveLeadership from "../assets/about-leadership/executive-icon.png";
import advisoryBoard from "../assets/about-leadership/advisory-icon.png";
import governanceFramework from "../assets/about-leadership/governance-icon.png";
import ethicsTransparency from "../assets/about-leadership/ethics-icon.png";
import manifestoCollage from "../assets/about-manifesto/collage.png";
import manifestoBelieveBg from "../assets/about-closing/shared-section-bg.png";
import manifestoIconLearn from "../assets/about-manifesto/icon-learn.png";
import manifestoIconInnovation from "../assets/about-manifesto/icon-innovation.png";
import manifestoIconCommunity from "../assets/about-manifesto/icon-community.png";
import manifestoIconIndustry from "../assets/about-manifesto/icon-industry.png";
import manifestoIconFuture from "../assets/about-manifesto/icon-future.png";
import commitmentCollage from "../assets/about-commitment/collage.png";
import commitmentIconSupport from "../assets/about-commitment/icon-support.png";
import commitmentIconIndustries from "../assets/about-commitment/icon-industries.png";
import commitmentIconInnovation from "../assets/about-commitment/icon-innovation.png";
import commitmentIconFuture from "../assets/about-commitment/icon-future.png";
import commitmentIconOpportunities from "../assets/about-commitment/icon-opportunities.png";
import engineeringIconQuality from "../assets/about-engineering/icon-quality.png";
import engineeringIconSustainable from "../assets/about-engineering/icon-sustainable.png";
import engineeringIconEconomic from "../assets/about-engineering/icon-economic.png";
import engineeringIconInfrastructure from "../assets/about-engineering/icon-infrastructure.png";
import engineeringIconIndustries from "../assets/about-engineering/icon-industries.png";
import engineeringIconInnovations from "../assets/about-engineering/icon-innovations.png";
import challengesSectionBg from "../assets/about-closing/shared-section-bg.png";
import challengesIconGuidance from "../assets/about-challenges/icon-guidance.png";
import challengesIconSkillGaps from "../assets/about-challenges/icon-skill-gaps.png";
import challengesIconUpskilling from "../assets/about-challenges/icon-upskilling.png";
import challengesIconEmployability from "../assets/about-challenges/icon-employability.png";
import challengesIconExposure from "../assets/about-challenges/icon-exposure.png";
import challengesIconTechChange from "../assets/about-challenges/icon-tech-change.png";
import closingSectionBg from "../assets/about-closing/shared-section-bg.png";
import purposeGraphic from "../assets/about-closing/purpose-graphic.png";
import visionIconEmpower from "../assets/about-closing/vision-empower.png";
import visionIconIndustry from "../assets/about-closing/vision-industry.png";
import visionIconInnovation from "../assets/about-closing/vision-innovation.png";
import visionIconCommunity from "../assets/about-closing/vision-community.png";
import visionIconGrowth from "../assets/about-closing/vision-growth.png";
import visionIconGlobal from "../assets/about-closing/vision-global.png";
import partnershipWhyPartner from "../assets/partnership-why-partner.webp";
import partnershipFramework from "../assets/partnership-framework.webp";
import whoServeStudents from "../assets/images/Image 1.webp";
import whoServeGraduates from "../assets/images/image2.webp";
import whoServeWomen from "../assets/images/Image (3).webp";
import whoServeEmerging from "../assets/images/Image (4).webp";

import whoServeEducation from "../assets/images/serve2.webp";
import whoServeIndustry from "../assets/images/serve1.webp";
import industryCollageTop from "../assets/home-industry/partnership-collage-top.png";
import industryCollageBl from "../assets/home-industry/partnership-collage-bl.png";
import industryCollageBr from "../assets/home-industry/partnership-collage-br.png";
import joinMovementHero from "../assets/home-join/join-movement-hero.png";
import impactSkillNew from "../assets/home-impact/impact-skill.png";
import impactCareer from "../assets/home-impact/impact-career.png";
import impactIndustryNew from "../assets/home-impact/impact-industry.png";
import impactInnovation from "../assets/home-impact/impact-innovation.png";
import impactCommunity from "../assets/home-impact/impact-community.png";
import impactNational from "../assets/home-impact/impact-national.png";
import impactIconHammer from "../assets/home-impact/icons/icon-hammer-navy.png";
import impactIconTrend from "../assets/home-impact/icons/icon-trend-navy.png";
import impactIconCollab from "../assets/home-impact/icons/icon-collab-navy.png";
import impactIconBulb from "../assets/home-impact/icons/icon-bulb-navy.png";
import impactIconPeople from "../assets/home-impact/icons/icon-people-navy.png";
import impactIconGlobe from "../assets/home-impact/icons/icon-globe-navy.png";

// Program Page Assets
import programHeroImg from "../assets/program/image 343.svg";
import programSkillDevImg from "../assets/program/Rectangle 4841.svg";
import programCareerGuideImg from "../assets/program/Rectangle 4841 (1).svg";
import programIndependentEngImg from "../assets/program/Rectangle 4841 (2).svg";
import programWelfareRecogImg from "../assets/program/Rectangle 4841 (3).svg";
import programIndustryAcademiaImg from "../assets/program/Rectangle 4841 (4).svg";
import programTechInnovationImg from "../assets/program/Rectangle 4841 (5).svg";
import programCommunityDevImg from "../assets/program/Rectangle 4841 (6).svg";
import programIndiaGrowthImg from "../assets/program/Rectangle 4841 (7).svg";
import programJoinBannerImg from "../assets/program/Frame 1000010357 (1).svg";

// What We Do Collage Cards
import whatCard1 from "../assets/images/card 1.webp";
import whatCard2 from "../assets/images/card 2.webp";
import whatCard3 from "../assets/images/card 3.webp";
import whatCard4 from "../assets/images/card 4.webp";
import whatCard5 from "../assets/images/card 5.webp";
import whatCard6 from "../assets/images/card 6.webp";
import whatCard7 from "../assets/images/card 7.webp";
import whatCard8 from "../assets/images/card 8.webp";
import whatCard9 from "../assets/images/card 9.webp";
import whatCard10 from "../assets/images/card 10.webp";
import whatCard11 from "../assets/images/card 11.webp";
import whatCard12 from "../assets/images/card 12.webp";

// About Us College Event Gallery
import galleryImage1 from "../assets/College_logos/Image1.webp";
import galleryImage2 from "../assets/College_logos/image2.webp";
import galleryImage3 from "../assets/College_logos/image3.webp";
import galleryImage4 from "../assets/College_logos/image4.webp";
import galleryImage5 from "../assets/College_logos/image5.webp";
import galleryImage6 from "../assets/College_logos/image6.webp";
import galleryImage7 from "../assets/College_logos/image7.webp";
import galleryImage8 from "../assets/College_logos/image8.webp";
import galleryImage9 from "../assets/College_logos/image9.webp";

// About Us Mission / Vision Icons
import zapIcon from "../assets/zap.svg";
import eyeIcon from "../assets/eye.svg";

// College Partner Logos (Home Page Marquee)
import logoB from "../assets/College_logos/bangalore institue .webp";
import logoBms from "../assets/College_logos/bms college.webp";
import logoBnm from "../assets/College_logos/bnm college.webp";
import logoCambridge from "../assets/College_logos/cambridge institue.webp";
import logoCiet from "../assets/College_logos/ciet logo.webp";
import logoDayanand from "../assets/College_logos/dayanand sagar college.webp";
import logoGm from "../assets/College_logos/gm college.webp";
import logoKns from "../assets/College_logos/kns college.webp";
import logoPresidency from "../assets/College_logos/presidency college.webp";
import logoRanganathar from "../assets/College_logos/ranganathar college polytechnic .webp";
import logoRvs from "../assets/College_logos/rvs college.webp";
import logoSea from "../assets/College_logos/sea college of institue.webp";
import logoSirM from "../assets/College_logos/sir_m_visvesvaraya_institute_of_technology_logo.webp";
import logoSriShaki from "../assets/College_logos/sri shaki college.webp";
import logoSrm from "../assets/College_logos/srm university.webp";
import logoTagore from "../assets/College_logos/tagore college.webp";

// Footer Assets
import footerTree from "../img/tree.webp";
import footerAssetLogo from "../img/asset.webp";

// Extended Assets (Empower, Program subpages, Partnership1)
import {
  EMPOWER_IMAGE_MAP,
  PROGRAM_IMAGE_MAP,
  PARTNERSHIP1_IMAGE_MAP,
  EXTENDED_IMAGE_OPTIONS,
} from "./cmsAssetsExtended";

/**
 * Maps CMS imageKey values to bundled static assets.
 * CMS may also return absolute URLs (uploaded media) — those pass through unchanged.
 */
export const CMS_IMAGE_MAP = {
  ...EMPOWER_IMAGE_MAP,
  ...PROGRAM_IMAGE_MAP,
  ...PARTNERSHIP1_IMAGE_MAP,
  image_hero: heroimage,
  asset_about: aboutTeam,
  our_impact: impactSkillNew,
  our_impact_1: impactCareer,
  our_impact_2: impactIndustryNew,
  our_impact_3: impactInnovation,
  our_impact_4: impactCommunity,
  our_impact_5: impactNational,
  impact_icon_hammer: impactIconHammer,
  impact_icon_trend: impactIconTrend,
  impact_icon_collab: impactIconCollab,
  impact_icon_bulb: impactIconBulb,
  impact_icon_people: impactIconPeople,
  impact_icon_globe: impactIconGlobe,
  meaningful: partnerMeaningful,
  crs: partnerCrs,
  industry: partnerIndustry,
  accountability: partnerAccountability,
  serve_frame1: serveFrame1,
  serve_frame2: serveFrame2,
  serve_frame3: serveFrame3,
  serve_frame4: serveFrame4,
  emerging_workforce: emergingWorkforce,
  through_skill: throughSkill,
  about_section_bg: aboutSectionBg,
  wesince: wesinceSeal,
  enhance_employability: enhanceEmployability,
  promote_innovation: promoteInnovation,
  infrastructure_awareness: infrastructureAwareness,
  socio_economic_inclusion: socioEconomicInclusion,
  architecture_practitioners: Architecture,
  engineering_professionals: Engineering,
  skill_development_trainers: SkillDevelopment,
  administrative_coordinators: Administrative,
  industry_mentors: IndustryMentors,
  research_contributors: ResearchContributors,
  executive_leadership: executiveLeadership,
  advisory_board: advisoryBoard,
  governance_framework: governanceFramework,
  ethics_transparency: ethicsTransparency,
  manifesto_collage: manifestoCollage,
  manifesto_believe_bg: manifestoBelieveBg,
  manifesto_icon_learn: manifestoIconLearn,
  manifesto_icon_innovation: manifestoIconInnovation,
  manifesto_icon_community: manifestoIconCommunity,
  manifesto_icon_industry: manifestoIconIndustry,
  manifesto_icon_future: manifestoIconFuture,
  commitment_collage: commitmentCollage,
  commitment_icon_support: commitmentIconSupport,
  commitment_icon_industries: commitmentIconIndustries,
  commitment_icon_innovation: commitmentIconInnovation,
  commitment_icon_future: commitmentIconFuture,
  commitment_icon_opportunities: commitmentIconOpportunities,
  engineering_icon_quality: engineeringIconQuality,
  engineering_icon_sustainable: engineeringIconSustainable,
  engineering_icon_economic: engineeringIconEconomic,
  engineering_icon_infrastructure: engineeringIconInfrastructure,
  engineering_icon_industries: engineeringIconIndustries,
  engineering_icon_innovations: engineeringIconInnovations,
  challenges_section_bg: challengesSectionBg,
  challenges_icon_guidance: challengesIconGuidance,
  challenges_icon_skill_gaps: challengesIconSkillGaps,
  challenges_icon_upskilling: challengesIconUpskilling,
  challenges_icon_employability: challengesIconEmployability,
  challenges_icon_exposure: challengesIconExposure,
  challenges_icon_tech_change: challengesIconTechChange,
  closing_section_bg: closingSectionBg,
  purpose_graphic: purposeGraphic,
  vision_icon_empower: visionIconEmpower,
  vision_icon_industry: visionIconIndustry,
  vision_icon_innovation: visionIconInnovation,
  vision_icon_community: visionIconCommunity,
  vision_icon_growth: visionIconGrowth,
  vision_icon_global: visionIconGlobal,
  partnership_why_partner: partnershipWhyPartner,
  partnership_framework: partnershipFramework,
  who_serve_students: whoServeStudents,
  who_serve_graduates: whoServeGraduates,
  who_serve_women: whoServeWomen,
  who_serve_emerging: whoServeEmerging,
  who_serve_education: whoServeEducation,
  who_serve_industry: whoServeIndustry,
  industry_collage_top: industryCollageTop,
  industry_collage_bl: industryCollageBl,
  industry_collage_br: industryCollageBr,
  join_movement_hero: joinMovementHero,

  // Program Page Map
  program_hero: programHeroImg,
  program_skill_dev: programSkillDevImg,
  program_career_guide: programCareerGuideImg,
  program_independent_eng: programIndependentEngImg,
  program_welfare_recog: programWelfareRecogImg,
  program_industry_academia: programIndustryAcademiaImg,
  program_tech_innovation: programTechInnovationImg,
  program_community_dev: programCommunityDevImg,
  program_india_growth: programIndiaGrowthImg,
  program_banner: programJoinBannerImg,

  // What We Do Cards
  what_we_do_card_1: whatCard1,
  what_we_do_card_2: whatCard2,
  what_we_do_card_3: whatCard3,
  what_we_do_card_4: whatCard4,
  what_we_do_card_5: whatCard5,
  what_we_do_card_6: whatCard6,
  what_we_do_card_7: whatCard7,
  what_we_do_card_8: whatCard8,
  what_we_do_card_9: whatCard9,
  what_we_do_card_10: whatCard10,
  what_we_do_card_11: whatCard11,
  what_we_do_card_12: whatCard12,

  // About Us College Event Gallery
  college_event_1: galleryImage1,
  college_event_2: galleryImage2,
  college_event_3: galleryImage3,
  college_event_4: galleryImage4,
  college_event_5: galleryImage5,
  college_event_6: galleryImage6,
  college_event_7: galleryImage7,
  college_event_8: galleryImage8,
  college_event_9: galleryImage9,

  // About Mission & Vision Icons
  about_mission_icon: zapIcon,
  about_vision_icon: eyeIcon,
  zap: zapIcon,
  eye: eyeIcon,

  // Home College Partner Logos
  partner_logo_cambridge: logoCambridge,
  partner_logo_bms: logoBms,
  partner_logo_dayanand: logoDayanand,
  partner_logo_ciet: logoCiet,
  partner_logo_kns: logoKns,
  partner_logo_bangalore_inst: logoB,
  partner_logo_gm: logoGm,
  partner_logo_bnm: logoBnm,
  partner_logo_srm: logoSrm,
  partner_logo_presidency: logoPresidency,
  partner_logo_ranganathar: logoRanganathar,
  partner_logo_sea: logoSea,
  partner_logo_rvs: logoRvs,
  partner_logo_sir_m: logoSirM,
  partner_logo_sri_shakti: logoSriShaki,
  partner_logo_tagore: logoTagore,

  // Footer Assets
  footer_tree: footerTree,
  footer_logo: footerAssetLogo,
};

/** Friendly labels for the CMS image picker dropdown. */
export const CMS_IMAGE_OPTIONS = [
  ...EXTENDED_IMAGE_OPTIONS,
  { value: "image_hero", label: "Hero background" },
  { value: "asset_about", label: "About section" },
  { value: "our_impact", label: "Impact — Skill development" },
  { value: "our_impact_1", label: "Impact — Career growth" },
  { value: "our_impact_2", label: "Impact — Industry-academia" },
  { value: "our_impact_3", label: "Impact — Innovation" },
  { value: "our_impact_4", label: "Impact — Community" },
  { value: "our_impact_5", label: "Impact — National growth" },
  { value: "impact_icon_hammer", label: "Impact icon — Hammer" },
  { value: "impact_icon_trend", label: "Impact icon — Trend" },
  { value: "impact_icon_collab", label: "Impact icon — Collaboration" },
  { value: "impact_icon_bulb", label: "Impact icon — Bulb" },
  { value: "impact_icon_people", label: "Impact icon — People" },
  { value: "impact_icon_globe", label: "Impact icon — Globe" },
  { value: "meaningful", label: "Partner — Meaningful impact" },
  { value: "crs", label: "Partner — CSR programs" },
  { value: "industry", label: "Partner — Industry programs" },
  { value: "accountability", label: "Partner — Governance" },
  { value: "serve_frame1", label: "Who we serve — Students" },
  { value: "serve_frame2", label: "Who we serve — Industry partners" },
  { value: "serve_frame3", label: "Who we serve — Women in tech" },
  { value: "serve_frame4", label: "Who we serve — Graduates" },
  { value: "emerging_workforce", label: "Who we serve — Emerging workforce" },
  { value: "through_skill", label: "About — Through skill" },
  { value: "about_section_bg", label: "About — Section background" },
  { value: "wesince", label: "About — Since seal" },
  { value: "enhance_employability", label: "Objective — Employability" },
  { value: "promote_innovation", label: "Objective — Innovation" },
  { value: "infrastructure_awareness", label: "Objective — Infrastructure" },
  { value: "socio_economic_inclusion", label: "Objective — Inclusion" },
  { value: "architecture_practitioners", label: "Team — Architecture" },
  { value: "engineering_professionals", label: "Team — Engineering" },
  { value: "skill_development_trainers", label: "Team — Skill trainers" },
  { value: "administrative_coordinators", label: "Team — Admin" },
  { value: "industry_mentors", label: "Team — Industry mentors" },
  { value: "research_contributors", label: "Team — Research" },
  { value: "executive_leadership", label: "Leadership — Executive" },
  { value: "advisory_board", label: "Leadership — Advisory" },
  { value: "governance_framework", label: "Leadership — Governance" },
  { value: "ethics_transparency", label: "Leadership — Ethics" },
  { value: "manifesto_collage", label: "Manifesto — Collage" },
  { value: "manifesto_believe_bg", label: "Manifesto — Believe background" },
  { value: "manifesto_icon_learn", label: "Manifesto — Learn icon" },
  { value: "manifesto_icon_innovation", label: "Manifesto — Innovation icon" },
  { value: "manifesto_icon_community", label: "Manifesto — Community icon" },
  { value: "manifesto_icon_industry", label: "Manifesto — Industry icon" },
  { value: "manifesto_icon_future", label: "Manifesto — Future icon" },
  { value: "commitment_collage", label: "Commitment — Collage" },
  { value: "commitment_icon_support", label: "Commitment — Support" },
  { value: "commitment_icon_industries", label: "Commitment — Industries" },
  { value: "commitment_icon_innovation", label: "Commitment — Innovation" },
  { value: "commitment_icon_future", label: "Commitment — Future" },
  { value: "commitment_icon_opportunities", label: "Commitment — Opportunities" },
  { value: "engineering_icon_quality", label: "Engineering — Quality of life" },
  { value: "engineering_icon_sustainable", label: "Engineering — Sustainable" },
  { value: "engineering_icon_economic", label: "Engineering — Economic growth" },
  { value: "engineering_icon_infrastructure", label: "Engineering — Infrastructure" },
  { value: "engineering_icon_industries", label: "Engineering — Industries" },
  { value: "engineering_icon_innovations", label: "Engineering — Innovations" },
  { value: "challenges_section_bg", label: "Challenges — Background" },
  { value: "challenges_icon_guidance", label: "Challenges — Guidance" },
  { value: "challenges_icon_skill_gaps", label: "Challenges — Skill gaps" },
  { value: "challenges_icon_upskilling", label: "Challenges — Upskilling" },
  { value: "challenges_icon_employability", label: "Challenges — Employability" },
  { value: "challenges_icon_exposure", label: "Challenges — Exposure" },
  { value: "challenges_icon_tech_change", label: "Challenges — Tech change" },
  { value: "closing_section_bg", label: "Closing — Section background" },
  { value: "purpose_graphic", label: "Purpose — Target graphic" },
  { value: "vision_icon_empower", label: "Vision — Empower" },
  { value: "vision_icon_industry", label: "Vision — Industry" },
  { value: "vision_icon_innovation", label: "Vision — Innovation" },
  { value: "vision_icon_community", label: "Vision — Community" },
  { value: "vision_icon_growth", label: "Vision — Growth" },
  { value: "vision_icon_global", label: "Vision — Global" },
  { value: "partnership_why_partner", label: "Partnership — Why partner" },
  { value: "partnership_framework", label: "Partnership — Framework" },
  { value: "who_serve_students", label: "Who we serve — Students" },
  { value: "who_serve_graduates", label: "Who we serve — Graduates" },
  { value: "who_serve_women", label: "Who we serve — Women" },
  { value: "who_serve_emerging", label: "Who we serve — Emerging" },
  { value: "who_serve_education", label: "Who we serve — Education" },
  { value: "who_serve_industry", label: "Who we serve — Industry" },
  { value: "industry_collage_top", label: "Industry partnerships — Collage top" },
  { value: "industry_collage_bl", label: "Industry partnerships — Collage bottom left" },
  { value: "industry_collage_br", label: "Industry partnerships — Collage bottom right" },
  { value: "join_movement_hero", label: "Join the Movement — Hero image" },

  // Program Options
  { value: "program_hero", label: "Programs — Hero image" },
  { value: "program_skill_dev", label: "Programs — Engineering Skill Development" },
  { value: "program_career_guide", label: "Programs — Career Guidance & Employability" },
  { value: "program_independent_eng", label: "Programs — Independent Engineer Initiative" },
  { value: "program_welfare_recog", label: "Programs — Engineer Welfare & Recognition" },
  { value: "program_industry_academia", label: "Programs — Industry-Academia Collaboration" },
  { value: "program_tech_innovation", label: "Programs — Technology & Innovation Development" },
  { value: "program_community_dev", label: "Programs — Engineering Community Development" },
  { value: "program_india_growth", label: "Programs — India Engineering Growth Mission" },
  { value: "program_banner", label: "Programs — Join Program Banner" },

  // What We Do
  { value: "what_we_do_card_1", label: "What We Do — Card 1 (Skill Dev Top)" },
  { value: "what_we_do_card_2", label: "What We Do — Card 2 (Skill Dev Bottom)" },
  { value: "what_we_do_card_3", label: "What We Do — Card 3 (Research Top)" },
  { value: "what_we_do_card_4", label: "What We Do — Card 4 (Research Bottom)" },
  { value: "what_we_do_card_5", label: "What We Do — Card 5 (Sustainable Top)" },
  { value: "what_we_do_card_6", label: "What We Do — Card 6 (Sustainable Bottom Left)" },
  { value: "what_we_do_card_7", label: "What We Do — Card 7 (Sustainable Bottom Right)" },
  { value: "what_we_do_card_8", label: "What We Do — Card 8 (CSR Top)" },
  { value: "what_we_do_card_9", label: "What We Do — Card 9 (CSR Bottom Left)" },
  { value: "what_we_do_card_10", label: "What We Do — Card 10 (CSR Bottom Right)" },
  { value: "what_we_do_card_11", label: "What We Do — Card 11 (National Top)" },
  { value: "what_we_do_card_12", label: "What We Do — Card 12 (National Bottom)" },

  // About Us College Event Gallery
  { value: "college_event_1", label: "About Gallery — College Event 1" },
  { value: "college_event_2", label: "About Gallery — College Event 2" },
  { value: "college_event_3", label: "About Gallery — College Event 3" },
  { value: "college_event_4", label: "About Gallery — College Event 4" },
  { value: "college_event_5", label: "About Gallery — College Event 5" },
  { value: "college_event_6", label: "About Gallery — College Event 6" },
  { value: "college_event_7", label: "About Gallery — College Event 7" },
  { value: "college_event_8", label: "About Gallery — College Event 8" },
  { value: "college_event_9", label: "About Gallery — College Event 9" },

  // About Icons
  { value: "about_mission_icon", label: "About — Mission Icon (Zap)" },
  { value: "about_vision_icon", label: "About — Vision Icon (Eye)" },

  // College Partner Logos
  { value: "partner_logo_cambridge", label: "Partner Logo — Cambridge Institute" },
  { value: "partner_logo_bms", label: "Partner Logo — BMS Institute" },
  { value: "partner_logo_dayanand", label: "Partner Logo — Dayananda Sagar College" },
  { value: "partner_logo_ciet", label: "Partner Logo — CIET College" },
  { value: "partner_logo_kns", label: "Partner Logo — KNS Institute" },
  { value: "partner_logo_bangalore_inst", label: "Partner Logo — Bangalore Institute" },
  { value: "partner_logo_gm", label: "Partner Logo — GM Institute" },
  { value: "partner_logo_bnm", label: "Partner Logo — BNM Institute" },
  { value: "partner_logo_srm", label: "Partner Logo — SRM University" },
  { value: "partner_logo_presidency", label: "Partner Logo — Presidency University" },
  { value: "partner_logo_ranganathar", label: "Partner Logo — Sri Ranganathar Polytechnic" },
  { value: "partner_logo_sea", label: "Partner Logo — SEA Group of Institutions" },
  { value: "partner_logo_rvs", label: "Partner Logo — RVS College" },
  { value: "partner_logo_sir_m", label: "Partner Logo — Sir M Visvesvaraya Institute" },
  { value: "partner_logo_sri_shakti", label: "Partner Logo — Sri Shakthi Institute" },
  { value: "partner_logo_tagore", label: "Partner Logo — Tagore Institute" },

  // Footer Assets
  { value: "footer_tree", label: "Footer — Tree Emblem Graphic" },
  { value: "footer_logo", label: "Footer — ASSET Typography Logo" },
];

export function resolveCmsImage(imageKeyOrUrl, apiBaseUrl) {
  if (!imageKeyOrUrl) return "";
  if (
    typeof imageKeyOrUrl === "string" &&
    (imageKeyOrUrl.startsWith("http://") ||
      imageKeyOrUrl.startsWith("https://") ||
      imageKeyOrUrl.startsWith("/api/") ||
      imageKeyOrUrl.startsWith("data:"))
  ) {
    if (imageKeyOrUrl.startsWith("/api/") && apiBaseUrl) {
      return `${apiBaseUrl.replace(/\/+$/, "")}${imageKeyOrUrl}`;
    }
    return imageKeyOrUrl;
  }
  if (CMS_IMAGE_MAP[imageKeyOrUrl]) {
    return CMS_IMAGE_MAP[imageKeyOrUrl];
  }
  if (typeof imageKeyOrUrl === "string" && imageKeyOrUrl.includes("/")) {
    return imageKeyOrUrl;
  }
  return "";
}

export function resolveCmsImagesInContent(content, apiBaseUrl) {
  if (!content || typeof content !== "object") return content;

  const clone = JSON.parse(JSON.stringify(content));

  const walk = (node) => {
    if (Array.isArray(node)) {
      node.forEach(walk);
      return;
    }
    if (node && typeof node === "object") {
      // Dynamically resolve any property ending in 'Key'
      Object.keys(node).forEach((k) => {
        if (k.endsWith("Key") && typeof node[k] === "string" && node[k].trim()) {
          const targetProp = k.slice(0, -3); // e.g. heroImageKey -> heroImage, imageKey -> image, iconKey -> icon
          const resolved = resolveCmsImage(node[k], apiBaseUrl);
          if (resolved) {
            node[targetProp] = resolved;
          }
        }
      });

      // Also handle explicit well-known keys
      if (node.imageKey) node.image = resolveCmsImage(node.imageKey, apiBaseUrl);
      if (node.image1Key) node.image1 = resolveCmsImage(node.image1Key, apiBaseUrl);
      if (node.image2Key) node.image2 = resolveCmsImage(node.image2Key, apiBaseUrl);
      if (node.image3Key) node.image3 = resolveCmsImage(node.image3Key, apiBaseUrl);
      if (node.logoKey) node.logo = resolveCmsImage(node.logoKey, apiBaseUrl);
      if (node.sealImageKey) node.sealImage = resolveCmsImage(node.sealImageKey, apiBaseUrl);
      if (node.backgroundImageKey) node.backgroundImage = resolveCmsImage(node.backgroundImageKey, apiBaseUrl);
      if (node.treeImageKey) node.treeImage = resolveCmsImage(node.treeImageKey, apiBaseUrl);
      if (node.logoImageKey) node.logoImage = resolveCmsImage(node.logoImageKey, apiBaseUrl);
      if (node.iconKey) node.icon = resolveCmsImage(node.iconKey, apiBaseUrl);

      Object.values(node).forEach(walk);
    }
  };

  walk(clone);
  return clone;
}
